import(/* webpackMode: "eager" */ "/srv/stocks-in-global/apps/web/app/(community)/error.tsx");
